import { BillingDetails, Organization } from "myfitworld-model";
import { firestore } from "../firebase";
import firebase from "firebase";
import {
  SUBSCRIPTION_ACTIVE,
  SUBSCRIPTION_AUTOMATIC_CANCEL,
  SUBSCRIPTION_CREATED_NEW,
  SUBSCRIPTION_CUSTOMER_CREATED,
  SUBSCRIPTION_USER_CANCEL
} from "../components/payment/utils";
import { DiscountProps } from "../pages/users/rebrandStepContent/RebrandDialogIndex";

const FUNCTIONS_BASE_URL = process.env.REACT_APP_FUNCTIONS_BASE_URL;

export const getOrganizationBillingDetails = (
  orgId: string
): Promise<BillingDetails | null> =>
  new Promise((resolve, reject) => {
    return firestore.collection('billingDetails').where(firebase.firestore.FieldPath.documentId(), '==', orgId).get().then((snapshot) => {
      snapshot.empty ? resolve(null) : resolve({ id: snapshot.docs[0].id, ...snapshot.docs[0].data() } as BillingDetails);
    }).catch((err) => {
      reject(null);
    })
  });

export const setOrganizationBillingDetails = (
  orgId: string,
  billingDetails: any
): Promise<BillingDetails | null> =>
  new Promise((resolve, reject) => {
    return firestore.collection('billingDetails').doc(orgId).update(billingDetails).then((snapshot) => {
    }).catch((err) => {
      console.log(err);
      reject(null);
    })
  });

export const createOrganizationBillingDetails = async (orgId: string, billingDetails: any) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/billingDetails/update/${orgId}`, {
    method: 'PUT',
    body: JSON.stringify(billingDetails),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}

export const updateOrganizationCardDetails = async (orgId: string, billingDetails: any) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/billingDetails/card/update/${orgId}`, {
    method: 'PUT',
    body: JSON.stringify(billingDetails),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}

export const updateOrganizationPlan = async (orgId: string, billingDetails: any) => { // ova je novi update plan
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/billingDetails/plan/update/${orgId}`, {
    method: 'PUT',
    body: JSON.stringify(billingDetails),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}

export const updateOrganizationBillingAddress = async (orgId: string, billingDetails: any) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/billingDetails/address/update/${orgId}`, {
    method: 'PUT',
    body: JSON.stringify(billingDetails),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}

export const listInvoices = async (customerID: string, subscriptionID: string) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/listInvoices/customer/${customerID}/subscription/${subscriptionID}`, {
    method: 'GET',
    headers: {
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}

export const listInvoicesCustomer = async () => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/listInvoices/customer`, {
    method: 'GET',
    headers: {
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}


export const getUpcomingInvoice = async (customerID: string, subscriptionID: string) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/upcomingInvoice/customer/${customerID}/subscription/${subscriptionID}`, {
    method: 'GET',
    headers: {
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}

export const cancelSubscription = async (orgID: string, subscriptionID: string) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/cancelSubscription/organization/${orgID}/subscription/${subscriptionID}`, {
    method: 'DELETE',
    headers: {
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}

export const cancelStripeConnectSubscription = async () => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/stripeConnect`, {
    method: 'DELETE',
    headers: {
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}

export const cancelSubscriptionAndResetClients = async (organizationID: string, subscriptionID: string) => {
  if (!(organizationID && subscriptionID)) { return }
  try {
    let res = await cancelSubscription(organizationID, subscriptionID).then((res) => { return res }, (err) => { console.log(err) })
    return res;
  } catch (error) {
    console.log(error)
    return false;
  }
}

export const listCoupons = async () => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/coupons/list`, {
    method: 'GET',
    headers: {
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}

export const isOrgWithUnlimitedOptions = async (orgId: string) => {
  const organizationDoc = await firestore.collection("organizations").doc(orgId).get();

  if (organizationDoc.exists) {
    const organization = organizationDoc.data() as Organization;

    if (organization.isWhiteLabel || organization.free || organization.haveRebrand) {
      return true;
    } else {
      const billingDetails = await getOrganizationBillingDetails(orgId);
      if (billingDetails !== null) {
        const invoiceState = billingDetails.invoiceState;
        if (invoiceState === SUBSCRIPTION_ACTIVE) {
          return true;
        }
      }
    }
  }
  return false;
}

export const isOrganizationOnTheFreePlanAndHasTwoClients = async (selectedOrganization: Organization | undefined): Promise<boolean> => {
  if (selectedOrganization && selectedOrganization.id) {
    const billingDetails = await getOrganizationBillingDetails(selectedOrganization.id);
    const quantity = billingDetails?.stripe?.quantity || 0;
    const state = billingDetails?.state;
    const invoiceState = billingDetails?.invoiceState;
    const isYoungerThan30days = isOrganizationYoungerThan30Days(selectedOrganization?.createdAt);

    if (isYoungerThan30days) return false;
    if((state === SUBSCRIPTION_CUSTOMER_CREATED || state === SUBSCRIPTION_USER_CANCEL) && !selectedOrganization.free && !isYoungerThan30days) return true;
    if(state === SUBSCRIPTION_CUSTOMER_CREATED && !selectedOrganization.free && quantity < 4 && selectedOrganization.haveRebrand) return false;
    if (selectedOrganization.free && !selectedOrganization.maxNumberOfFreeClients) return false;
    if (selectedOrganization.free && selectedOrganization.maxNumberOfFreeClients && selectedOrganization?.maxNumberOfFreeClients <= quantity) return true;
    if (state === SUBSCRIPTION_CREATED_NEW && invoiceState === SUBSCRIPTION_ACTIVE) return false;

    return false;
  }

  return false;
}

export type ClientAdditionSubscriptionRequirement = | "none" | "update_subscription" | "update_card";

export const getClientAdditionSubscriptionRequirement = async (
  selectedOrganization: Organization | undefined
): Promise<ClientAdditionSubscriptionRequirement> => {
  if (!selectedOrganization?.id) {
    return "none";
  }

  const isYoungerThan30days = isOrganizationYoungerThan30Days(selectedOrganization.createdAt);
  if (isYoungerThan30days) {
    return "none";
  }

  const billingDetails = await getOrganizationBillingDetails(selectedOrganization.id);
  const priceId = billingDetails?.stripe?.priceId;
  const paymentMethodId = billingDetails?.stripe?.paymentMethodId;
  const subscriptionState = billingDetails?.state;

  if (
    subscriptionState === SUBSCRIPTION_USER_CANCEL ||
    subscriptionState === SUBSCRIPTION_AUTOMATIC_CANCEL
  ) {
    return "update_subscription";
  }

  if (!priceId) {
    return "update_subscription";
  }

  if (!paymentMethodId) {
    return "update_card";
  }

  return "none";
};

export const isOrganizationYoungerThan30Days = (createdAt?: any): boolean => {
  if (!createdAt) return false;

  const createdAtMs = createdAt.seconds * 1000;
  const nowMs = Date.now();

  const DAYS_30_MS = 30 * 24 * 60 * 60 * 1000;

  return nowMs - createdAtMs < DAYS_30_MS;
};

export const createStripeAccount = async ({orgId, userId}:{orgId: string, userId: string}) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/stripeConnect/create-account-link`, {
    method: 'POST',
    body: JSON.stringify({
      orgId: orgId,
      userId: userId
    }),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return response;
}

export type SelectedPlanType =
  | "standard"
  | "rebrand_month"
  | "rebrand_yearly"
  | "rebrand_lifetime"
  | "REBRAND_BUNDLE_0_10_3M"
  | "REBRAND_BUNDLE_0_10_6M"
  | "REBRAND_BUNDLE_0_25_6M"
  | "REBRAND_BUNDLE_0_25_12M"
  | "REBRAND_BUNDLE_0_55_12M";

export const getSelectedPlanTypeFromPriceId = (priceId: string): SelectedPlanType | null => {
  if (
    priceId === process.env.REACT_APP_STANDARD_BASE ||
    priceId === process.env.REACT_APP_STANDARD_BASE_NO_FLAT ||
    priceId === process.env.REACT_APP_STANDARD_BASE_RB
  ) return "standard";
  if (priceId === process.env.REACT_APP_STRIPE_REBRAND_MONTHLY) return "rebrand_month";
  if (priceId === process.env.REACT_APP_STRIPE_REBRAND_YEARLY) return "rebrand_yearly";
  if (priceId === process.env.REACT_APP_STRIPE_REBRAND_ONE) return "rebrand_lifetime";
  if (priceId === process.env.REACT_APP_REBRAND_BUNDLE_0_10_3M) return "REBRAND_BUNDLE_0_10_3M";
  if (priceId === process.env.REACT_APP_REBRAND_BUNDLE_0_10_6M) return "REBRAND_BUNDLE_0_10_6M";
  if (priceId === process.env.REACT_APP_REBRAND_BUNDLE_0_25_6M) return "REBRAND_BUNDLE_0_25_6M";
  if (priceId === process.env.REACT_APP_REBRAND_BUNDLE_0_25_12M) return "REBRAND_BUNDLE_0_25_12M";
  if (priceId === process.env.REACT_APP_REBRAND_BUNDLE_0_55_12M) return "REBRAND_BUNDLE_0_55_12M";

  return null;
};

type CreateOrUpdatePayload = {
  selectedPlanType: SelectedPlanType;
  selectedPriceId: string;
  email?: string;
  phone?: string;
  billing_address?: {
    address?: string;
    city?: string;
    countryCode?: string;
    postalCode?: string;
    stateCode?: string;
    taxID?: string;
  };
  stripe?: {
    customerId?: string;
    paymentMethodId?: string;
  };
  card?: {
    name?: string;
    exp_month?: number;
    exp_year?: number;
    last4?: string;
  };
};

export const createOrUpdateSubscription = async (orgId: string, payload: CreateOrUpdatePayload) => {
  const token = await firebase.auth().currentUser?.getIdToken();

  const response = await fetch(
    `${FUNCTIONS_BASE_URL}/billingDetails/plan/create-or-update/${orgId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: JSON.stringify(payload),
    }
  );

  return response;
};

export const createRebrandSubscription = async (
  customerId: string,
  rebrandPriceId: string,
  orgId: string,
  paymentType: string,
  paymentMethodId: string,
  userAdminEmail: string,
  orgName: string,
  paymentInterval: string,
  coupon?: DiscountProps
) => {
  try {
    const token = await firebase.auth().currentUser?.getIdToken();

    const response = await fetch(`${FUNCTIONS_BASE_URL}/billingDetails/create-rebrand-subscription`, {
      method: 'POST',
      body: JSON.stringify({
        customerId,
        rebrandPriceId,
        orgId,
        paymentType,
        paymentMethodId,
        userAdminEmail,
        orgName,
        paymentInterval,
        coupon
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? 'Bearer ' + token : ''
      }
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        ok: false,
        ...data
      };
    }

    return {
      ok: true,
      ...data
    };

  } catch (error) {
    return {
      ok: false,
      error: error || 'Unknown error'
    };
  }
}

export const cancelRebrandSubscription = async (subscriptionId: string, orgId: string, paymentType: string, subscriptionScheduleId: string) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  return await fetch(`${FUNCTIONS_BASE_URL}/billingDetails/cancel-rebrand-subscription`, {
    method: 'POST',
    body: JSON.stringify({ subscriptionId, orgId, paymentType, subscriptionScheduleId }),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
}

export const manageRebrandSubscription = async (subscriptionId: string, rebrandPriceId: string, organizationId: string, paymentInterval: string) => {
  const token = await firebase.auth().currentUser?.getIdToken();

  return await fetch(`${FUNCTIONS_BASE_URL}/billingDetails/update-rebrand-subscription`, {
    method: 'POST',
    body: JSON.stringify({
      subscriptionId,
      rebrandPriceId,
      organizationId,
      paymentInterval
    }),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
}

export const stripeConnectLoginURL = async (organizationStripeConnectId: undefined | string) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/stripeConnectLoginURL`, {
    method: 'POST',
    body: JSON.stringify({
      stripeConnectID: organizationStripeConnectId
    }),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });

  return await response.json();
}

export const stripeConnectProduct = async (data: {
  type: string,
  id: string | undefined,
  locked: boolean,
  price_in: number | undefined,
  enName: string,
  stripeProduct?: string
}) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/stripeConnect/products`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });

  return await response.json();
}

export const stripeConnectPaymentLink = async (data: {
  stripeAccountId: string,
  stripeProductId: string,
  contentId: string,
  contentType: "workouts" | "programs"
}) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/stripeConnect/paymentLink`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });

  return await response.json();
}

export const stripeConnectStartSubscription = async () => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/stripeConnect/start-subscription`, {
    method: 'GET',
    headers: {
      'Authorization': token ? 'Bearer ' + token : ''
    }
  });
  return await response.json();
}
